import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { ApplicationState } from '../../store';

export interface PrivateRouteType {
  component: React.FC;
  path: string;
  exact?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteType> = (
  props: PrivateRouteType,
) => {
  const { component, path, exact } = props;

  const isLoggedIn = useSelector(
    (state: ApplicationState) =>
      state.auth.isLoggedIn || state.distributor.isLoggedIn,
  );

  return isLoggedIn ? (
    <Route path={path} exact={exact} component={component} />
  ) : (
    <Redirect to="/login" />
  );
};

export default PrivateRoute;
